// extracted by mini-css-extract-plugin
export var Wrapper = "Form-module--Wrapper--hBknq";
export var LangHY = "Form-module--LangHY--714am";
export var TextFieldWrap = "Form-module--TextFieldWrap--AEAjz";
export var TextAreaWrap = "Form-module--TextAreaWrap--dYIK1";
export var Policy = "Form-module--Policy--7ZhNg";
export var Title = "Form-module--Title--DZcfP";
export var Form = "Form-module--Form--SJabZ";
export var openThank = "Form-module--open-thank--oqRwj";
export var LineField = "Form-module--LineField--Bhzcn";
export var FormControl = "Form-module--FormControl--j-Ig6";
export var ThankWrap = "Form-module--ThankWrap--Aj1c4";
export var arrowLeft = "Form-module--arrowLeft--JA9K8";
export var arrowRight = "Form-module--arrowRight--BQNyZ";